import { type PropsWithChildren } from 'react';

import { useGraphSize } from '../../core/components/chart-layout/hooks/useGraphSize.js';
import { useFormatter } from '../context/FormatterContext.js';
import { useLabelsDisplay } from '../context/LabelsDisplayContext.js';
import { TreeMapAggregationDataContext } from '../context/TreeMapAggregationDataContext.js';
import { useTreeMapInternalData } from '../context/TreeMapInternalDataContext.js';
import { useAggregatedData } from '../hooks/useAggregatedData.js';
import { useVisibleNodes } from '../hooks/useVisibleNodes.js';
import { withParentLabel } from '../utils/with-parent-label.js';

export const TreeMapAggregationDataProvider = (props: PropsWithChildren) => {
  const { children } = props;
  const { width, height } = useGraphSize();
  const roundedWidth = Math.floor(width);
  const roundedHeight = Math.floor(height);
  const internalData = useTreeMapInternalData();
  const labelsDisplay = useLabelsDisplay();
  const formatter = useFormatter();

  const hasParentLabels = withParentLabel(labelsDisplay);

  const treemapArea = roundedWidth * roundedHeight;

  const visibleNodes = useVisibleNodes(internalData);
  const { dataForRendering, dataForHighlighting } = useAggregatedData(
    visibleNodes,
    treemapArea,
    hasParentLabels,
    formatter,
  );

  return (
    <TreeMapAggregationDataContext.Provider
      value={{ dataForRendering, dataForHighlighting }}
    >
      {children}
    </TreeMapAggregationDataContext.Provider>
  );
};

TreeMapAggregationDataProvider['displayName'] =
  'TreeMapAggregationDataProvider';
